import React, {useState} from "react";
import Modal from '../../component/Inc/Modal';
import Tab from "../../component/Inc/Tab";
function PopManageEmployee(props) {
  const { open, close } = props;  
  const [modalAlert, setModalAlert] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title:"부서 등록", value:0},
    {title:"팀 등록", value:3},
  ];
  return (
    <Modal open={open} close={close} type="com_input com_manage_company pop_manage_employee">
      <h2 className='pop_tit'>직원관리</h2>
      <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="full"/>
        {tabIdx === 0 ? 
          <div className="content_container scroll">
            <input type="text" className="input" placeholder="출판사업부"/>
            <div className="com_btn_wrap center">
              <button className="com_btn orange xs">등록</button>
            </div>
            <div className="list">
              <div className="check">
                {[1,2,3,4,5,6,7,8,9].map((i, idx) => {
                  return (
                    <div className="check_item" key={idx}>
                      <input
                        type="radio"
                        name="chk1"
                        id={`chk1_${idx}`}
                        className="com_chk"
                      />
                      <label htmlFor={`chk1_${idx}`}>
                        출판사업부
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          :
          <>
            <div className="content_container scroll">
              <div className="list">
                <div className="check">
                  {[1,2,3,4,5,6,7,8,9].map((i, idx) => {
                  return (
                    <div className="check_item" key={idx}>
                      <input
                        type="radio"
                        name="chk"
                        id={`chk_${idx}`}
                        className="com_chk"
                      />
                      <label htmlFor={`chk_${idx}`}>
                        출판사업부
                      </label>
                    </div>
                  );
                })}
                </div>
              </div>
              <div className="tit">팀 선택</div>
                <div className="list">
                  <div className="check">
                    {[1,2,3,4,5,6,7,8,9].map((i, idx) => {
                    return (
                      <div className="check_item" key={idx}>
                        <input
                          type="radio"
                          name="chk2"
                          id={`chk2_${idx}`}
                          className="com_chk"
                        />
                        <label htmlFor={`chk2_${idx}`}>
                          출판사업부
                        </label>
                      </div>
                    );
                  })}
                  </div>
              </div>
              <input type="text" className="input" placeholder="내용 입력" />
            </div>
            <div className="btn_container">
              <button className="com_btn gray xs" onClick={() => setModalAlert(true)}>삭제</button>
              <button className="com_btn orange xs">등록</button>
            </div>
          </>
        }
        <Modal open={modalAlert} close={() => setModalAlert(false)} type="type_alert">
          <div className="content_container">
            <div className="txt">
              삭제시 등록된 직원은 <br />
              부서가 없어지게 됩니다.<br />
              삭제 하시겠습니까?
            </div>
            <div className="btn_container">
              <button className="com_btn gray xs" onClick={() => setModalAlert(false)}>취소</button>
              <button className="com_btn orange xs">삭제</button>
            </div>
          </div>
        </Modal>
    </Modal>
  );
}

export default PopManageEmployee;